import api from "../utils/api";
import { isGuid } from "../utils/string";

export const save = ({ uuid, required1099, expenseAccountUuid, meta }) => async () => {
  try {
    const res = await api.post("/vendors", { uuid, required1099, expenseAccountUuid, meta });
    return res.data;
  } catch (error) {
    return { success: false, error: error?.response?.data?.error || error };
  }
};

export const destroy = ({ uuid }) => async () => {
  try {
    const res = isGuid(uuid) ? await api.delete(`/vendors/i/${uuid}`) : { data: { success: false } };
    return res.data;
  } catch (err) {
    return { success: false, error: err?.response?.data?.error || err };
  }
};

export const get = ({ uuid }) => async () => {
  try {
    const res = isGuid(uuid) ? await api.get(`/vendors/i/${uuid}`) : { data: { success: false } };
    return res.data;
  } catch (err) {
    return { success: false, error: err?.response?.data?.error || err };
  }
};

export const search = ({
  page = 0,
  size = 100,
  order = "Person.displayName",
  direction = "ASC",
  search = "",
} = {}) => async () => {
  try {
    const route = `/vendors/p/${page}/s/${size}/o/${order}/${direction}`;
    const res = await api.get(search ? `${route}/${encodeURIComponent(search)}` : route);
    return res.data;
  } catch (err) {
    return { success: false, items: [], count: 0, error: err?.response?.data?.error || err };
  }
};
